import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import sr from "./locales/sr.json";
import en from "./locales/en.json";
import ru from "./locales/ru.json";

const LANG_KEY = "admin_lang";

export type AdminLang = "sr" | "en" | "ru";

function detectLanguage(): AdminLang {
  const stored = localStorage.getItem(LANG_KEY);
  if (stored === "sr" || stored === "en" || stored === "ru") return stored;
  const browser = navigator.language.slice(0, 2).toLowerCase();
  if (browser === "ru") return "ru";
  return "sr";
}

i18n.use(initReactI18next).init({
  resources: {
    sr: { translation: sr },
    en: { translation: en },
    ru: { translation: ru },
  },
  lng: detectLanguage(),
  fallbackLng: "sr",
  interpolation: { escapeValue: false },
});

export function setLanguage(lang: AdminLang) {
  i18n.changeLanguage(lang);
  localStorage.setItem(LANG_KEY, lang);
}
